import { cn } from '../utils';

/**
 * The "powered by POP.STORE" footer mark, shared across surfaces (checkout,
 * subscribe, …). Renders only the markup + a bold brand; ALL color/size styling
 * comes from the caller's `className` so each surface stays on its own palette
 * (checkout passes its `checkout-*` tokens, subscribe passes `gray-*`), with no
 * cross-borrowing of feature tokens.
 */
export function PoweredByPopStore({ className }: { className?: string }) {
  return (
    <p className={cn('text-[13px]', className)}>
      powered by <span className="font-bold">POP.STORE</span>
    </p>
  );
}
